import React from 'react';
import './index.css';

export const daysOfWeek: { [key: string]: number } = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
};

interface WeekdayCalendarProps {
  availableDays: number[];
  setAvailableDays: (days: number[]) => void;
}

const WeekdayCalendar: React.FC<WeekdayCalendarProps> = ({ availableDays = [], setAvailableDays }) => {
  const toggleDay = (value: [string, number]) => {
    if (availableDays.includes(value[1])) {
      setAvailableDays(availableDays.filter(d => d !== value[1]));
    } else {
      setAvailableDays([...availableDays, value[1]]);
    }
  };

  return (
    <div className="weekday-calendar">
      {Object.entries(daysOfWeek).map((value) => (
        <div
          key={value[0]}
          className={`day ${availableDays.includes(value[1]) ? 'selected' : ''}`}
          onClick={() => toggleDay(value)}
        >
          {value[0]}
        </div>
      ))}
    </div>
  );
};

export default WeekdayCalendar;
